<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TRI01D/tc-custom/cover.jpg?1685327062238?1692044794125" alt="This image is the cover for the book Breaking the Bonds, Cascade City Pack"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breaking the Bonds, Cascade City Pack
      </h1>
      <p class="bookDescription body article font2">
        <p>Sequel to <i>A New Beginning</i><br/><br/>Proof that a small but powerful group of humans have developed a chemical compound that controls werewolves from shifting as well as preventing them from reproducing throws the shifter community into turmoil.<br/><br/>For the past couple of years, Jax has remained in a loveless marriage in hopes of gathering enough evidence to convict those responsible for harming his werewolf friends. He is horrified when he discovers an underground omega sex trafficking ring, the omegas of which are under the influence of the sinister compound.<br/><br/>With Jax’ acting as informant, the FBI plus  alphas from various local werewolf packs manage to break into the sex trafficking den, arrest those responsible,  and save the beleaguered omegas. However, will an antidote to the sinister compound be formulated in time to heal them?<br/><br/>Jax believes he’s tainted because of what he’s seen and was forced to do. Can his lovers, David and Brooks, convince him he’s a hero not a traitor?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca James
      </h2>
      
      <p class="authorDescription body article">A wife and the mother of three children, Rebecca James resides in the southern United States. She has a B.A. in English Literature and loves writing both contemporary and paranormal M/M romance. For more information, visit rebeccajamesgayromance.wordpress.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?613e5465